
export const TEMPLATE = `<ng-content></ng-content>`;





// WEBPACK FOOTER //
// ./src/app/library/ngu-utility/letter-avatar/template.ts